<div>
  <h2>Datos Destinatario</h2>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">DNI</span>
    <input id="destino_cuit" [(ngModel)]="sr.destino_cuit" type="number" class="form-control"
       aria-label="destinoDni" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text">Nombre y Apellido</span>
    <input id="destino_nombre" [(ngModel)]="sr.destino_nombre" type="text" aria-label="destinoNombre"
      class="form-control">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">E-Mail</span>
    <input id="destino_email" [(ngModel)]="sr.destino_email" type="text" class="form-control" aria-label="destinoEmail"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Telefono</span>
    <input id="destino_telefono" [(ngModel)]="sr.destino_telefono" type="number" class="form-control"
      aria-label="destinoTelefono" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Provincia</span>
    <input id="destino_provincia" [(ngModel)]="sr.destino_provincia" type="text" class="form-control"
      aria-label="destinoProvincia" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Localidad</span>
    <input id="destino_localidad" [(ngModel)]="sr.destino_localidad" type="text" class="form-control"
      aria-label="destinoLocalidad" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Direccion</span>
    <input id="destino_direccion" [(ngModel)]="sr.destino_direccion" type="text" class="form-control"
      aria-label="destinoDireccion" aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Entre Calles</span>
    <input id="destino_altura" [(ngModel)]="sr.destino_entrecalles" type="text" class="form-control"
      aria-label="destinoAltura" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Codigo Postal</span>
    <input id="destino_cp" [(ngModel)]="sr.destino_cp" type="number" class="form-control" aria-label="destinoCp"
      aria-describedby="inputGroup-sizing-default">
    <span class="input-group-text" id="inputGroup-sizing-default">Piso departamento</span>
    <input id="destino_piso_departamento" [(ngModel)]="sr.destino_piso_departamento" type="text" class="form-control"
      aria-label="origen_piso_departamento" aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">SR Asociada</span>
    <input id="dni" type="number" class="form-control" aria-label="dni" aria-describedby="inputGroup-sizing-default" [(ngModel)]="et.id_sr" readonly>
  </div>
  <!-- <div class="form-check form-check-inline">
    <span class="input-group-text" id="inputGroup-sizing-default">Tipo de Envio</span>
    <input type="radio" class="btn-check" name="options-outlined" id="success-outlined" autocomplete="off" checked>
    <label class="btn btn-outline-primary" for="success-outlined" (click)="tipoEnvio(5)">Al Centro</label>

    <input type="radio" class="btn-check" name="options-outlined" id="danger-outlined" autocomplete="off">
    <label class="btn btn-outline-primary" for="danger-outlined" (click)="tipoEnvio(6)">Envio Rapido</label>
  </div> -->
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Vehiculo</span>
    <select class="form-select" aria-label="Select Vehiculo" [(ngModel)]="et.id_vehiculo">
      <option *ngFor="let m of vehiculos" value={{m.id}}>{{m.marca +" "+ m.modelo+" ("+m.patente + ") "+ m.detalle}}</option>
    </select>
  </div>

  <div *ngIf="et.id_estado < 7 && sr.estado !== 4" class="form-floating text-center justify-content-md-end col-12 row" >
    <div class="col-3">
      <button type="button" class="btn btn-success" (click)="recibirEt(6)" *ngIf="et.id_estado < 6"  >En Transito</button>
    </div>
    <div class="col-3">
      <button type="button" class="btn btn-primary" (click)="recibirEt(7)" *ngIf="et.id_estado === 6"  >Conforme</button>
    </div>
    <div class="col-3">
      <button type="button" class="btn btn-primary" (click)="enviar()" >Modificar</button>
    </div>
    <div class="col-3">
      <button type="button" class="btn btn-danger" (click)="recibirEt(4)" *ngIf="et.id_estado < 7" >Rechazar</button>
    </div>
  </div>

</div>
